module.exports = __webpack_public_path__ + "img/transactions.0ff2714f.svg";